import { useMutation } from "urql";
import { graphql } from "@acto/gql";
import { useCallback, useState } from "react";

const DeleteMeetingMutation = graphql(`
  mutation DeleteMeeting($id: ID!) {
    deleteMeeting(id: $id) {
      id
      client {
        id
        legacyId
        name
        __typename
      }
    }
  }
`);

export function useDeleteMeeting() {
  const [result, deleteMeetingMutation] = useMutation(DeleteMeetingMutation);
  const [error, setError] = useState<Error | null>(null);

  const deleteMeeting = useCallback(
    async (id: string) => {
      try {
        const response = await deleteMeetingMutation({ id });
        if (response.error) {
          throw response.error;
        }
        return response.data?.deleteMeeting;
      } catch (err: unknown) {
        if (err instanceof Error) {
          setError(err);
          return null;
        } else {
          throw err;
        }
      }
    },
    [deleteMeetingMutation],
  );

  return { deleteMeeting, result, error };
}
